/* eslint-disable typescript-sort-keys/string-enum */

enum NftAssetSize {
  Size32 = "Size32",
  Size48 = "Size48",
  Size64 = "Size64",
  Size72 = "Size72",
  Size96 = "Size96",
  Size120 = "Size120",
  Size188 = "Size188",
  Size234 = "Size234",
  Size320 = "Size320",
  Size480 = "Size480",
  Size588 = "Size588",
  Size100Percent = "Size100Percent",
}

export default NftAssetSize;
